/**
 * @overview AvatarGrid component
 */
import cx from 'classnames';
import React from 'react';
import { getUniqueKey } from '../../_utils';
import { Avatar } from '../avatar';
import styles from './avatar-grid.module.scss';
export const AvatarGrid = ({ id, className, items = [], ...restProps }) => items.length ? (React.createElement("div", { className: cx(styles.container, className), ...restProps, id: id }, items.map((item) => (React.createElement(Avatar, { key: getUniqueKey(item), name: item.name, src: item.src, size: "l", showName: true, namePosition: "bottom", className: styles.avatarGroupItem }))))) : null;
//# sourceMappingURL=avatar-grid.js.map